module.exports = __webpack_public_path__ + "static/media/pic_individualplan.afc6d4a9.jpg";